// theme toggle: flip between dark and light, persist in localStorage.
// flash prevention is handled by an inline script in base.liquid.
const themeToggle = document.querySelector('.theme-toggle')
if (themeToggle) {
  themeToggle.addEventListener('click', () => {
    const current = document.documentElement.dataset.theme
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const effective = current || (prefersDark ? 'dark' : 'light')
    const next = effective === 'dark' ? 'light' : 'dark'
    document.documentElement.dataset.theme = next
    try {
      localStorage.setItem('theme', next)
    } catch (e) {}
  })
}

// progressive enhancement on .lightbox-trigger anchors: intercept the click
// and open a shared <dialog> with the picture re-sized to viewport. native
// <dialog> handles esc-to-close and focus management for free.

const dialog = document.querySelector('#lightbox')
if (dialog) {
  const stage = dialog.querySelector('.lightbox-stage')

  document.querySelectorAll('.lightbox-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const source = trigger.querySelector('picture')
      if (!source) return

      const cloned = source.cloneNode(true)
      // let the browser pick the largest available variant for the viewport
      cloned.querySelectorAll('source, img').forEach((el) => {
        if (el.hasAttribute('sizes')) el.setAttribute('sizes', '100vw')
      })
      // drop layout hints so css can fit the image to the viewport
      const img = cloned.querySelector('img')
      if (img) {
        img.removeAttribute('width')
        img.removeAttribute('height')
        img.removeAttribute('loading')
        img.removeAttribute('fetchpriority')
      }

      stage.replaceChildren(cloned)
      dialog.showModal()
    })
  })

  // close on any click — backdrop, stage, or the image itself
  dialog.addEventListener('click', () => dialog.close())

  // empty the stage on close so the next open starts from scratch
  dialog.addEventListener('close', () => {
    stage.replaceChildren()
  })
}
